var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"clearable":false,"required":true,"loading":_vm.loading,"options":_vm.companyOptions,"reduce":function (option) { return option.value; },"value":_vm.value},on:{"input":_vm.setValue}})}
var staticRenderFns = []

export { render, staticRenderFns }